import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import {
  Box,
  TextField,
  Button,
  CircularProgress,
  Switch,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";
import { createChecklistPergunta } from "../../api/checkilstApi";

type FormValues = {
  descricao_checklist_pergunta: string;
  obrigatorio_checklist_pergunta: boolean;
  ordem_checklist_pergunta: number;
};

const NovaPergunta: React.FC = () => {
  const { grupoId } = useParams<{ grupoId: string }>();
  const id_checklist_grupo = Number(grupoId);
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);

  const { control, handleSubmit } = useForm<FormValues>({
    defaultValues: {
      descricao_checklist_pergunta: "",
      obrigatorio_checklist_pergunta: false,
      ordem_checklist_pergunta: 0,
    },
  });

  const onSubmit = async (form: FormValues) => {
    try {
      setSaving(true);
      const token = localStorage.getItem("token") || "";

      const payload = {
        descricao_checklist_pergunta: form.descricao_checklist_pergunta,
        obrigatorio_checklist_pergunta: form.obrigatorio_checklist_pergunta,
        ordem_checklist_pergunta: Number(form.ordem_checklist_pergunta),
        id_checklist_grupo,
      };

      const created = await createChecklistPergunta(token, payload);

      toast.success("Pergunta criada com sucesso!");

      if (created?.id) {
        navigate(`/editarChecklist/pergunta/${created.id}`);
      } else {
        navigate(-1);
      }
    } catch (err) {
      console.error(err);
      toast.error("Erro ao criar pergunta");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 900 }}>
      <Typography variant="h5" mb={2}>
        Nova Pergunta - Grupo #{id_checklist_grupo}
      </Typography>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="descricao_checklist_pergunta"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Descrição da Pergunta"
              fullWidth
              margin="normal"
              required
            />
          )}
        />

        <Controller
          name="ordem_checklist_pergunta"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Ordem da Pergunta"
              type="number"
              fullWidth
              margin="normal"
            />
          )}
        />

        <Controller
          name="obrigatorio_checklist_pergunta"
          control={control}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Switch
                  checked={!!field.value}
                  onChange={(e) => field.onChange(e.target.checked)}
                />
              }
              label="Obrigatória"
            />
          )}
        />

        <Box mt={2} display="flex" gap={2}>
          <Button variant="contained" type="submit" disabled={saving}>
            {saving ? <CircularProgress size={24} /> : "Salvar Pergunta"}
          </Button>
          <Button variant="outlined" onClick={() => navigate(-1)}>
            Voltar
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default NovaPergunta;
